import { mermaidCapability } from './mermaid';

let library;
let sequence = 0;
let pending = Promise.resolve();
export function checkMermaidSource(source) {
  if (source.length > 100000) throw new Error('Mermaid source exceeds 100,000 characters.');
  if (/^\s*(%%\{|---|click\s|link\s|links\s|style\s|classDef\s)/m.test(source) || /<\/?[a-z!]|@\{|\b(?:https?:|javascript:|data:)/i.test(source)) {
    throw new Error('Mermaid directives, HTML, external resources and custom styles are not supported. The canvas was not changed.');
  }
  if (mermaidCapability(source).type === 'unsupported') throw new Error('This Mermaid diagram type is not supported. Use flowchart, graph, sequenceDiagram, erDiagram, gantt or pie. The canvas was not changed.');
}
async function getMermaid() {
  if (!library) library = import('mermaid').then(module => {
    module.default.initialize({ startOnLoad: false, securityLevel: 'strict', suppressErrorRendering: true, maxTextSize: 100000, maxEdges: 1000, theme: 'default', fontFamily: 'Arial, sans-serif', htmlLabels: false, flowchart: { htmlLabels: false }, logLevel: 'fatal' });
    return module.default;
  });
  return library;
}
export function mermaidError(error) {
  const line = error?.hash?.loc?.first_line;
  const detail = String(error?.message || 'Unable to render Mermaid.').slice(0, 700);
  return `Invalid Mermaid syntax${line ? ` on line ${line}` : ''}: ${detail}`;
}
// Mermaid uses shared rendering state. Serialize it; results are revision-checked
// by the panel before either preview or canvas is changed.
export function renderMermaid(source) {
  const work = async () => {
    checkMermaidSource(source);
    const mermaid = await getMermaid();
    const container = document.createElement('div');
    container.style.cssText = 'position:fixed;left:-100000px;top:0;width:1200px;visibility:hidden';
    document.body.appendChild(container);
    try {
      await mermaid.parse(source);
      const result = await mermaid.render(`cobygo-mermaid-${++sequence}`, source, container);
      if (result.svg.length > 4 * 1024 * 1024) throw new Error('Rendered diagram exceeds the preview size limit.');
      // SVG is displayed as an image, never inserted into the application's DOM.
      // SVG image mode does not execute scripts or load external subresources.
      return result.svg;
    } catch (error) { throw new Error(mermaidError(error)); }
    finally { container.remove(); }
  };
  const result = pending.then(work, work);
  pending = result.catch(() => {});
  return result;
}
